import React from 'react';
import styles from './style.module.css';
import clsx from 'clsx';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  width?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  children: React.ReactNode;
  className?: string;
  topBottomMargin?: boolean | string | number; // true = use default class, else use custom value
  topMargin?: string | number;
  bottomMargin?: string | number;
}

const Heading: React.FC<HeadingProps> = ({
  as: Tag = 'h1',
  children,
  width,
  style,
  className,
  topBottomMargin,
  topMargin,
  bottomMargin,
  ...rest
}) => {
  const convertMargin = (value: string | number | undefined) => {
    if (typeof value === 'number') return `${value}px`;
    if (typeof value === 'string') return value;
    return undefined;
  };

  const marginStyle = {
    ...(topBottomMargin !== undefined && typeof topBottomMargin !== 'boolean'
      ? {
          marginTop: convertMargin(topBottomMargin),
          marginBottom: convertMargin(topBottomMargin),
        }
      : {}),
    ...(topMargin !== undefined ? { marginTop: convertMargin(topMargin) } : {}),
    ...(bottomMargin !== undefined ? { marginBottom: convertMargin(bottomMargin) } : {}),
  };

  const combinedStyle = {
    ...(width ? { width } : {}),
    ...marginStyle,
    ...style,
  };

  return (
    <Tag
      style={combinedStyle}
      className={clsx(
        styles.heading,
        topBottomMargin === true && styles.margin,
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Heading;
